// extracted by mini-css-extract-plugin
export var statItem = "_md-1";
export var statsRow = "_md-0";